import * as React from 'react'
import { useContext, useEffect, useState } from 'react'
import {render} from 'react-dom'

import "../../css/app.scss"

import {AppProvider,AppContext} from "../Context/AppContext"

import {Login} from './Login'
import {Dashboard} from './Dashboard'
import axios from 'axios'

function App() {
    return <AppProvider>
        <Content/>
    </AppProvider>
}

function Content() {

    const { token, setToken, setRole } = useContext(AppContext)

    axios.interceptors.request.use(
        (config) => {
            return config;
        },
        (error) => {
            Promise.reject(error);
        },
    );

    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const originalRequest = error.config;
            if (error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
                const res = await axios.post('/api-v0/token/refresh', { withCredentials: true });
                if (res.status === 200) {
                    setToken(res.data.access_token);
                    return axios(originalRequest);
                } else {
                    await axios.post('/api-v0/disconnection');
                }
            }
            return Promise.reject(error);
        },
    );

    useEffect(() => {
        axios.get('/api-v0/token', { withCredentials: true }).then((res) => {
            setToken(res.data.access_token);
            setRole(res.data.role)
        });
    }, []);

    return <>
        {token?<Dashboard />:<Login />}
    </>
}

render(<App/>,document.querySelector("#app"))